/**
*   Product Options Table
*/
const rows = document.querySelectorAll('.js-product-variants-table [data-row-variant-index]');
const tableAddtoCartButton = document.querySelector('.js-table-add-to-cart');

// Function to update row price display
function updateRowPrice(row) {
    const quantityInput = row.querySelector('.row-variant-quantity-input');
    const unitPriceElement = row.querySelector('.unit-price');
    const totalPriceElement = row.querySelector('.total-price');
    
    if (!totalPriceElement) return;
    
    const quantity = parseInt(quantityInput.value) || 0;
    const unitPrice = parseFloat(row.getAttribute('data-variant-price')) || 0;
    
    if (quantity > 1) {
        const totalPrice = (unitPrice * quantity / 100).toFixed(2);
        totalPriceElement.textContent = ` (Total: $${totalPrice})`;
        totalPriceElement.style.display = 'inline';
    } else {
        totalPriceElement.style.display = 'none';
    }
}

// Function to update overall cart total
function updateOverallTotal() {
    const totalElement = document.querySelector('.variants-table-total');
    if (!totalElement) return;
    
    let overallTotal = 0;
    
    rows.forEach(row => {
        const quantityInput = row.querySelector('.row-variant-quantity-input');
        const quantity = parseInt(quantityInput.value) || 0;
        const unitPrice = parseFloat(row.getAttribute('data-variant-price')) || 0;
        
        if (quantity > 0) {
            overallTotal += (unitPrice * quantity);
        }
    });
    
    if (overallTotal > 0) {
        totalElement.textContent = `Total: $${(overallTotal / 100).toFixed(2)}`;
        totalElement.style.display = 'block';
    } else {
        totalElement.style.display = 'none';
    }
}

// Function to update row opacity based on quantity
function updateRowOpacity(row) {
    const quantityInput = row.querySelector('.row-variant-quantity-input');
    const quantity = parseInt(quantityInput.value) || 0;
    
    if (quantity === 0) {
        row.classList.add('row-variant--zero-quantity');
    } else {
        row.classList.remove('row-variant--zero-quantity');
    }
    
    // Update price display when opacity changes
    updateRowPrice(row);
    updateOverallTotal();
}

// Function to check if any variants have quantity > 0 and update button state
function updateAddToCartButtonState() {
    if (!tableAddtoCartButton) return;
    
    const allQuantityInputs = document.querySelectorAll('.js-product-variants-table .row-variant-quantity-input');
    let hasQuantity = false;
    
    allQuantityInputs.forEach(input => {
        const quantity = parseInt(input.value) || 0;
        if (quantity > 0) {
            hasQuantity = true;
        }
    });
    
    // Disable/enable button based on whether any quantity is selected
    tableAddtoCartButton.disabled = !hasQuantity;
    
    // Add visual styling for disabled state
    if (!hasQuantity) {
        tableAddtoCartButton.classList.add('button--disabled');
    } else {
        tableAddtoCartButton.classList.remove('button--disabled');
    }
}

if (rows) {
    rows.forEach(row => {
        let qtyDecrease = row.querySelector('.quantity__button-decrease');
        let qtyIncrease = row.querySelector('.quantity__button-increase');
        let qtyInput    = row.querySelector('.row-variant-quantity-input');
        let button      = row.querySelector('.js-table-add-to-cart-single');

        // Set initial opacity, price, and button state
        updateRowOpacity(row);
        updateAddToCartButtonState();

        // on decrement, update the quantity
        if (qtyDecrease) qtyDecrease.onclick = () => { 
            updateQuantity(parseInt(qtyInput.value) - 1);
        };

        if (qtyIncrease) qtyIncrease.onclick = () => {
            updateQuantity(parseInt(qtyInput.value) + 1);
        };

        // Handle direct input changes
        if (qtyInput) {
            qtyInput.addEventListener('input', () => {
                updateRowOpacity(row);
                updateAddToCartButtonState();
            });
        }

        if (button) {
            button.onclick = () => {
                let variantId   = row.getAttribute('data-variant-id');
                let qty         = row.querySelector('.row-variant-quantity-input') ? row.querySelector('.row-variant-quantity-input').value : 0;

                addTableItemsToCart([{ id: variantId, quantity: qty }]);
            }
        }

         function updateQuantity(value) {
            if (value < 0) value = 0; // Allow 0 instead of preventing it

            qtyInput.value = value;
            updateRowOpacity(row); // Update opacity after quantity change
            updateAddToCartButtonState(); // Update button state
        }
    });
}

if (tableAddtoCartButton) {
    tableAddtoCartButton.onclick = () => {
        const rows       = document.querySelectorAll('.js-product-variants-table .row-variant');
        const itemsToAdd = [];

        rows.forEach(row => {
            let variantId   = row.getAttribute('data-variant-id');
            let qty         = row.querySelector('.row-variant-quantity-input') ? row.querySelector('.row-variant-quantity-input').value : 0;

            // Only add items with quantity > 0
            if (qty > 0) itemsToAdd.push({ id: variantId, quantity: qty });
        });

        addTableItemsToCart(itemsToAdd);
    }
}

function addTableItemsToCart(itemsToAdd) {
    if (!tableAddtoCartButton || itemsToAdd.length < 1) return;

    const buttonText     = tableAddtoCartButton.querySelector('.button-text');
    const loadingOverlay = tableAddtoCartButton.querySelector('.loading-overlay__spinner');
    let formData         = { 'items': itemsToAdd };
    let cart             = document.querySelector('.drawer');

    if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }

    buttonText.classList.add('hidden');
    loadingOverlay.classList.remove('hidden');

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
    .then(response => {
        buttonText.classList.remove('hidden');
        loadingOverlay.classList.add('hidden');

        location.href = routes.cart_url;
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}